module.exports = __webpack_public_path__ + "static/media/glyphicons-halflings-regular.89889688.svg";


//////////////////
// WEBPACK FOOTER
// ./html/assets/fonts/bootstrap/glyphicons-halflings-regular.svg
// module id = 677
// module chunks = 0